import * as React from 'react';

import { CardEventType } from '../Stats/utils';
import { cardColorClass } from './cardColorClass';

interface Props extends React.ComponentProps<'div'> {
  color: CardEventType;
}

export const CardIcon: React.FC<Props> = ({
  color,
  className = '',
  ...divProps
}) => {
  const bgClass = cardColorClass[color];
  return (
    <div
      {...divProps}
      className={`${bgClass} w-3 h-4 rounded-sm inline-block ${className}`}
    ></div>
  );
};
